import { colors } from "@/styles/colors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	title: {
		fontSize: 18,
		fontWeight: 600
	},
	questionLabel: {
		marginBottom: 8,
		fontSize: 14,
		fontWeight: 500,
		color: colors.gray[800]
	}
})

export default useStyles
